import { useLocation } from "react-router";

const usePathChunk = () => {
  const location = useLocation();

  const getPathChunk = (chuckAt = 1) => {
    return location.pathname?.split("/").at(chuckAt);
  };

  return { getPathChunk };
};

export default usePathChunk;
